import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {TenantApiService} from "../../../../core/services/tenant-api/tenant-api.service";
import {ApiRequests} from "../../../../core/api.routes";
import {ResetPasswordService} from "../../../../core/services/reset-password/reset-password.service";
import {Subscription} from "rxjs";
import {NgIf} from "@angular/common";
import {BoostrapModalService} from "../../../../core/services/boostrap-modal/boostrap-modal.service";
import {DataService} from "../../../../core/services/data-service/data.service";
import {TokenKeys} from "../../../../core/token.keys";
import {ToastService} from "../../../../core/services/toast-service/toast.service";

@Component({
  selector: 'app-user-reset-password',
  templateUrl: './user-reset-password.component.html',
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule
  ],
  styleUrl: './user-reset-password.component.scss'
})
export class UserResetPasswordComponent implements OnInit {
  @Output() passwordReset = new EventEmitter<{ password: string }>();

  resetForm: FormGroup;

  isVisible = false;
  private subscription!: Subscription;
  protected isProcessing: boolean;

  @ViewChild('myButton') myButton: ElementRef;


  constructor(private fb: FormBuilder,
              private tenantService:TenantApiService,
              private resetPasswordService:ResetPasswordService,
              private bootstrapModalService:BoostrapModalService,
              private dataService:DataService,private toast:ToastService) {
    this.resetForm = this.fb.group({
      oldPassword: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', Validators.required],
    }, { validator: this.passwordsMatchValidator });

  }

  ngOnInit(): void {
    this.subscription = this.resetPasswordService.isResetModalVisible$.subscribe(
        (visible) => {

          this.isVisible = visible;

          if(visible){
            this.bootstrapModalService.open('userResetPasswordModal')
          }else{
            this.bootstrapModalService.close()
          }
        }
    );
  }

  passwordsMatchValidator(form: FormGroup) {
    const password = form.get('password')?.value;
    const confirm = form.get('confirmPassword')?.value;
    return password === confirm ? null : { mismatch: true };
  }

  onSubmit(): void {
    if (this.resetForm.valid) {
      this.passwordReset.emit({ password: this.resetForm.value.password });
    }

    this.isProcessing =true

    let password = this.resetForm.value.oldPassword,
     newPassword = this.resetForm.value.password;

    let id = this.dataService.getValue(TokenKeys.userId)

    this.tenantService.post(ApiRequests.UpdateUserPassword+"?id="+id+"&password="+password+"&newPassword="+newPassword , this.resetForm.value).subscribe({
      next: (resp:any) => {
        //update the user that the password has been reset
        this.isProcessing=false;
        if(resp.statusCode ==200){
          this.toast.showSuccess("Successfully updated",'Success');
          this.resetForm.reset();
        }

        this.myButton.nativeElement.click();

        this.closeForm()
      },
      error: err => {
        //handle the error
        this.isProcessing=false;
        this.toast.showError(err.response.data,'Unable to update password');

      }
    })
  }

  closeForm() {
    this.resetPasswordService.hideResetModal()
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
